export default "__VITE_ASSET__DwRpbGGs__"